const data = [
  { id: 1, name: 'INIT' },
  { id: 2, name: 'CREDITOR_SELECTION' },
  { id: 3, name: 'TERMS_REVIEW' },
  { id: 4, name: 'ALL_CONFIRMED' },
  { id: 5, name: 'OPTION_SELECTION' },
  { id: 6, name: 'PDF_GENERATION' },
  { id: 7, name: 'PDF_UPLOAD' },
  { id: 8, name: 'FINALIZED' },
]

export const EVENT_STEP = data.reduce((acc, item) => {
  acc[item.name] = item.id
  return acc
}, {})

export default [...data]
